<template>
    <a href="#" @click.prevent="exportClicked">
        <slot></slot>
    </a>
</template>

<script>
    export default {
        name: "ExportLink",
        props: {
            type: String,
            transaction: String,
            shapeType: {
                type: String,
                default: ''
            }
        },

        methods: {
            exportClicked: function() {
                $('#exportMessage').text('Your file is currently being generated. If this is the first time you\'ve accessed this file, it may take a significant amount of time before it is ready.');
                $('.loader').show();
                let url = '/exp/' + this.type + '/' + this.transaction;
                let component = this;
                if (this.shapeType !== '') {
                    url = url + '/' + this.shapeType;
                }
                window.axios.get(url)
                    .then(function (response) {
                        let data = response.data;
                        if (data.status === 'done') {
                            $('.loader').hide();
                            if (data.data.url.startsWith('http')) {
                                window.vm1.showModal = false;
                                window.location = data.data.url;
                            }
                        } else if (data.status === 'error') {
                            $('.loader').hide();
                            $('#exportMessage').text(data.error.message);
                            window.vm1.showModal = true;
                        } else {
                            window.vm1.showModal = true;
                            component.watchStatus(component.transaction + component.type, 0, 5000)
                        }
                    })
                    .catch(function (error) {
                        window.vm1.showModal = true;
                        $('.loader').hide();
                        if (error.response.data === undefined) {
                            $('#exportMessage').text(error.message);
                        } else {
                            let data = error.response.data;
                            if (data.status === 'error' && data.error.type !== 'internal')
                                $('#exportMessage').text(error.response.data.message);
                            else
                                $('#exportMessage').text('An internal error has occurred. This has been automatically reported to us, but if you continue to see this message, please contact support.');

                        }
                    });
            },

            watchStatus: function(statusKey, checkCount, sleepTime) {
                let component = this;
                window.axios.get('/exp/status/' + statusKey)
                    .then(function (response) {
                        let data = response.data;
                        if (data.status === 'done') {
                            $('.loader').hide();
                            if (data.data.url.startsWith('http')) {
                                window.vm1.showModal = false;
                                window.location = data.data.url;
                            }
                        } else if (data.status === 'running') {
                            if (checkCount > 10) {
                                sleepTime = 10000;
                            }
                            checkCount++;
                            window.vm1.showModal = true;
                            $('#exportMessage').text(data.data.state);
                            setTimeout(function () {
                                component.watchStatus(statusKey, checkCount, sleepTime);
                            }, sleepTime);
                        } else if (data.status === 'error') {
                            if (data.error.type === 'status') {
                                window.vm1.showModal = true;
                                $('.loader').hide();
                                $('#exportMessage').text(data.error.message);
                            } else {
                                window.vm1.showModal = true;
                                $('.loader').hide();
                                $('#exportMessage').text('An internal error has occurred. This has been automatically reported to us, but if you continue to see this message, please contact support.');
                            }
                        }
                    })
                    .catch(function (error) {
                        window.vm1.showModal = true;
                        $('.loader').hide();
                        if (error.response.data === undefined) {
                            $('#exportMessage').text(error.message);
                        } else {
                            let data = error.response.data;
                            if (data.status === 'error' && data.error.type !== 'internal')
                                $('#exportMessage').text(error.response.data.message);
                            else
                                $('#exportMessage').text('An internal error has occurred. This has been automatically reported to us, but if you continue to see this message, please contact support.');

                        }
                    });
            }
        }
    }
</script>

<style scoped>

</style>
